export default __webpack_public_path__ + "static/media/icons8-safari.f728badd.svg";